/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Bold_Kind_Toad_TiltInputs */

const en_bold_kind_toad_tilt = /** @type {(inputs: Bold_Kind_Toad_TiltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} is manager of`)
};

const de_bold_kind_toad_tilt = /** @type {(inputs: Bold_Kind_Toad_TiltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} ist Manager von ...`)
};

/**
* | output |
* | --- |
* | "{displayName} is manager of" |
*
* @param {Bold_Kind_Toad_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_kind_toad_tilt = /** @type {((inputs: Bold_Kind_Toad_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Kind_Toad_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_kind_toad_tilt(inputs)
	return de_bold_kind_toad_tilt(inputs)
});